import get from "lodash/get";

import { SEGMENT_ID } from "app/components/dashboard/widget-wizard/components/segments/constants";
import type { WebSourceType } from "app/pages/industry-analysis/category-share/CategoryShareTypes";
import type {
    EnrichedData,
    SwitchGraphDomainData,
    TableRawData,
} from "app/pages/industry-analysis/players/market-shares/types";

export const parseTableRawData = (data: SwitchGraphDomainData[], webSource: WebSourceType): EnrichedData => {
    const enrichedData = data.reduce((enrichedData, record) => {
        const { Favicon: favicon, Metrics: metrics, Id: id, DisplayName, Domain: domain } = record;
        const webSourceData = metrics.find((data) => data.WebSource === webSource);
        const { AvgMonthVisits: monthlyVisits, AvgMonthVisitsShare: trafficShare } = webSourceData.TotalMetrics;
        const regionalDomains = webSourceData.RegionalDomains;
        return {
            ...enrichedData,
            [id]: {
                monthlyVisits,
                trafficShare,
                favicon,
                id,
                regionalDomains,
                name: DisplayName,
                domain: domain || id,
            },
        };
    }, {});
    return enrichedData;
};

export const parseTableRawDataForWidget = (tableRawData: TableRawData, keys?: Record<string, any>): EnrichedData => {
    const { Data: data } = tableRawData;

    const enrichedData = data.reduce((acc, record) => {
        const {
            Favicon: favicon,
            AvgMonthVisits: monthlyVisits,
            Share: trafficShare,
            Id: id,
            Domain: recordDomain,
            Type: type,
        } = record;
        const currentItem = keys && keys.find((k) => k.id === id);

        const segmentName = get(currentItem, "segmentName", "");
        const itemType = get(currentItem, "type", "");
        const segmentDomain = get(currentItem, "domain", "");
        const nameDomain = get(currentItem, "name", "");
        const subtitleText = get(currentItem, "subtitleText", "");
        const defaultIsSegment = get(currentItem, "isSegment", "");

        const segmentId = type === 2 ? id : undefined;
        const isSegment = defaultIsSegment || itemType === SEGMENT_ID;

        const domain = isSegment ? segmentDomain || nameDomain : recordDomain;
        const name = segmentName || subtitleText;

        return {
            ...acc,
            [id]: {
                isSegment,
                domain: domain || recordDomain,
                name,
                segmentId,
                monthlyVisits,
                trafficShare,
                favicon,
                id,
            },
        };
    }, {});

    return enrichedData;
};
